import React from 'react';
import ReactPlayer from 'react-player';

import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { grey } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  content: {
    borderBottom: `1px solid ${grey[200]}`,
    borderTop: `1px solid ${grey[200]}`,
    padding: '20px 10px',
  },
}));

export default function TutorialModal(props) {
  const { open, handleClose } = props;
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>
        <div className={classes.title}>
          <span>Ajuda do sistema</span>
          <IconButton onClick={handleClose}>
              <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <ReactPlayer
          url='videos/tutorial.mp4'
          width='100%'
          height='100%'
          controls
        />
      </DialogContent>
    </Dialog>
  );
}
